import { Col, Form, Row } from "react-bootstrap";

import {
  RecursivePartialSiteAllowStringValues,
  SiteAllowStringValues,
} from "@inrange/building-manager-api-client/models-site";
import { BorderedCheckbox } from "@inrange/theme-components";
import CollapsibleCard from "../CollapsibleCard";

const SiteFeatureFlags = ({
  site,
  setSite,
  isBulkEdit,
}: {
  site: SiteAllowStringValues;
  setSite: (site: RecursivePartialSiteAllowStringValues) => void;
  isBulkEdit?: boolean;
}) => {
  return (
    <CollapsibleCard
      title={"Site feature flags"}
      className="mt-2"
      isBulkEdit={isBulkEdit}
      initialOpen={false}
    >
      <Row className="d-flex flex-wrap align-items-end">
        <Col sm={4}>
          <Form.Label>Enable DST shift</Form.Label>
          <Form
            style={{
              display: "flex",
              fontSize: 12,
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <BorderedCheckbox
              dataTestId={`dstShiftDemand-true}`}
              formName="dstShiftDemand"
              value={"true"}
              label={"True"}
              selectedOption={site.flags.dstShiftDemand ? "true" : "false"}
              setSelectedOption={(value) =>
                setSite({
                  flags: {
                    dstShiftDemand: value === "true",
                  },
                })
              }
            />
            <BorderedCheckbox
              dataTestId={`dstShiftDemand-false}`}
              formName="dstShiftDemand"
              value={"false"}
              label={"False"}
              selectedOption={site.flags.dstShiftDemand ? "true" : "false"}
              setSelectedOption={(value) =>
                setSite({
                  flags: {
                    dstShiftDemand: value === "true",
                  },
                })
              }
            />
          </Form>
        </Col>
        <Col sm={4}>
          <Form.Group className="mb-3" controlId="cplVersion">
            <Form.Label>Computed loss factors</Form.Label>
            <Form.Select
              value={site.flags.cplVersion || "v1"}
              onChange={(e) =>
                setSite({
                  flags: {
                    cplVersion: e.target.value,
                  },
                })
              }
            >
              <option value={"v1"}>V1 - Clipping</option>
              <option value={"v2"}>
                V2 - Clipping (improved), PV Temperature
              </option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Label>TMY filter outliers</Form.Label>
          <Form
            style={{
              display: "flex",
              fontSize: 12,
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <BorderedCheckbox
              dataTestId={`tmyFilterOutliers-true}`}
              formName="tmyFilterOutliers"
              value={"true"}
              label={"True"}
              selectedOption={site.flags.tmyFilterOutliers ? "true" : "false"}
              setSelectedOption={(value) =>
                setSite({
                  flags: {
                    tmyFilterOutliers: value === "true",
                  },
                })
              }
            />
            <BorderedCheckbox
              dataTestId={`tmyFilterOutliers-false}`}
              formName="tmyFilterOutliers"
              value={"false"}
              label={"False"}
              selectedOption={site.flags.tmyFilterOutliers ? "true" : "false"}
              setSelectedOption={(value) =>
                setSite({
                  flags: {
                    tmyFilterOutliers: value === "true",
                  },
                })
              }
            />
          </Form>
        </Col>
      </Row>
    </CollapsibleCard>
  );
};

export default SiteFeatureFlags;
